import { IAddress } from "../vue-interfaces/i-address";
import { IDiagnosisValue } from "../vue-interfaces/i-diagnosis";
import { IPatientDme } from "../vue-interfaces/i-get-dme";
import { IPatientSupply } from "../vue-interfaces/i-get-supply";
import { IHospiceConvertToPendingPatient } from "../vue-interfaces/i-hospice-convertopending-patient";
import { IPriorHospice } from "../vue-interfaces/i-prior-hospice";
import { IGetPatientTag } from "../vue-interfaces/i-providers-service";
import { PriorHospice } from "./prior-hospice";
import { IPharmacy } from "../vue-interfaces/i-pharmacy";
import { CahpsSurveyRecipientEnum } from "../../enums/ReferralEnums/CahpsSurveyRecipientEnum";

export class HospiceConvertToPendingPatient {
    public id: string = "";
    public associatedTaskId?: string = "";
    public locationId: string = "";
    public providerId: string = "";
    public currentReferralId: string = "";
    public caseManagerId: string = "";
    public clinicalManagerId: string = "";
    public admittingNurseId: string = "";
    public socialWorkerId: string = "";
    public hospiceAideId: string = "";
    public volunteerCoordinatorId: string = "";
    public bereavementCoordinatorId: string = "";
    public spiritualCounselorId: string = "";
    public firstName: string = "";
    public lastName: string = "";
    public suffix: string = "";
    public middleInitial: string = "";
    public gender: number;
    public isReferral: boolean;
    public referralId: string = "";
    public dateOfBirth: string = "";
    public medicalRecordNumber: string = "";
    public socialSecurityNumber: number;
    public isDoNotResuscitate: boolean;
    public maritalStatus: number;
    public isTransfer?: boolean = false;
    public benefitPeriodNumber?: number = null;
    public createInitialAssessment?: boolean;
    public createFaceToFaceDoc?: boolean;
    public sourceType: string = "";
    public primaryAddress: IAddress;
    public faceSheetComments: string = "";
    public visitAddress: IAddress;
    public isVisitAddressSameAsPrimary: boolean;
    public isMailingAddressSameAsPrimary: boolean;
    public mailingAddress: IAddress;
    public phoneNumbers: {
        id: string;
        number: string;
        extension: string;
        country: string;
        type: number;
        isPrimary: boolean;
    }[];
    public email: string = "";
    public locationOfPatient: string = "";
    public primaryLanguage: string = "";
    public languages: string[] = [];
    public interpreter: number[] = [];
    public otherInterpreter: string = "";
    public auxiliaryAids: string = "";
    public referralDate: string = "";
    public inquiryDate: string = "";
    public medicareNumber: number;
    public medicarePartD: string = "";
    public medicareNumberNA: number;
    public medicareBeneficiaryIdentification: string = "";
    public medicareBeneficiaryIdentificationNA: boolean;
    public medicaidNumber: string = "";
    public notAMedicaid: boolean;
    public patientCurrentLocation: string = "";
    public medicaidPending: boolean;
    public paymentSource: number[] = [];
    public veteran: number[] = [];
    public ethnicity: number[] = [];
    public hispanicEthnicity: number;
    public hispanicEthnicityValues: number[] = [];
    public race: number[] = [];
    public serviceCurrentlyReceiving: number[] = [];
    public specifyService: string = "";
    public advancedDirective: {
        hasLegalDocumentation: boolean;
        isCarePlanDocumented: boolean;
        isSurrogateDocumented: boolean;
        advancedCarePlanDirectives: number[];
        other: string;
        attorneyName: string;
        attorneyRelationship: string;
        medicalPreferences: string;
        mentalPreferences: string;
        culturalPreferences: string;
        spiritualPreferences: string;
        surrogateDecisionMaker: string;
        codeStatus: number[];
    };
    public patientFuneralHome: {
        id: string;
        name: string;
        address: string;
        city: string;
        state: string;
        zipCode: string;
        phoneNumber: string;
        afterHrsPhoneNumber: string;
    };
    public dmEs: IPatientDme[] = [];
    public supplies: IPatientSupply[] = [];
    public emergencyPreparednessPriority: number;
    public emergencyPreparednessInformation: number[] = [];
    public additionalEmergencyInformation: string = "";
    public evacuationZone: number = 0;
    public evacuationPrimaryPhoneNumber: {
        number: string;
        extension: string;
        country: string;
        type: number;
        isPrimary: boolean;
    };
    public evacuationAlternatePhoneNumber: {
        number: string;
        extension: string;
        country: string;
        type: number;
        isPrimary: boolean;
    };
    public isEvacuationAddressSameAsEmergencyContact: boolean;
    public evacuationAddress: {
        accountId?: string;
        addressLine1: string;
        addressLine2: string;
        city: string;
        state: string;
        zipCode: string;
        county: string;
        country?: string;
        longitude: number;
        latitude: number;
        isValidated: boolean;
        isBypassed: boolean;
    };
    public attendingPhysicianId: string = "";
    public attendingPhysicianName: string = "";
    public hospicePhysicianId: string = "";
    public isPhysicianOrderReceived: boolean;
    public additionalPhysicians: string[] = [];
    public referringDiagnosis: {
        description: string;
        code: string;
    };
    public admittingDiagnosis: {
        description: string;
        code: string;
    };
    public diagnoses: Array<IDiagnosisValue> = [];
    public pharmacies: string[] = [];
    public dmeVendors: string[] = [];
    public status: number;
    public sourceOfReferral: number;
    public facilityReferralSourceId: string = "";
    public facilityReferralSourceName: string = "";
    public facilityReferralSourceContactName: string = "";
    public physicianReferralSourceId: string = "";
    public physicianReferralSourceName: string = "";
    public physicianReferralSourceContactName: string = "";
    public otherReferralSourceRelationship: number;
    public otherReferralSourceName: string = "";
    public communityLiaisonId: string = "";
    public communityLiaisonName: string = "";
    public internalReferralSourceId: string = "";
    public internalReferralSourceName: string = "";
    public lineOfService: number;
    public additionalLineOfService: string = "";
    public sameAsAttendingPhysician: boolean;
    public admissionType: number;
    public admissionSource: number;
    public careTeamId: string = "";
    public internalReferralSource: number;
    public comments: string = "";
    public currentAdmissionDate: string = "";
    public prevDischargeDate: string = "";
    public primaryAddressFacilityTypeId: string = "";
    public visitAddressFacilityTypeId: string = "";
    public mailingAddressFacilityTypeId: string = "";
    public completedBy: string = "";
    public completedDate: string = "";
    public isCopyObtained: boolean;
    public verbalCertification: string = "";
    public hospicePhysicianCertifiedId: string = "";
    public hospicePhysicianCertificationDate: string = "";
    public hospiceVerbalCertificationBy: string = "";
    public attendingPhysicianCertifiedId: string = "";
    public attendingPhysicianCertificationDate: string = "";
    public attendingVerbalCertificationBy: string = "";
    public hasRoomAndBoard: boolean;
    public hasFamilyPortalAccess: boolean;
    public tags: IGetPatientTag[] = [];
    public tagIds: string[] = [];
    public pendingReason: number;
    public pendingReasonComment: string = "";
    public tolerablePainLevel: number;
    public priorHospice?: IPriorHospice = new PriorHospice();
    public certifyingPhysicianId?: string = "";
    public patientTransferTypeChanged?: boolean = false;
    public interpreterResponse?: number;
    public recipientType?: CahpsSurveyRecipientEnum;
    public recipientId?: string = "";
    public unsolicitedReason?: string = "";

    public constructor(data?: IHospiceConvertToPendingPatient) {
        if (!!data) {
            Object.assign(this, data);
        }
    }
}
